import {clearfix, colors} from '@xpertdox_js/xdstyle';

const statusContainer = {
  border: '1px solid',
  borderRadius: '4px',
  padding: '6px',
  fontSize: '1.25rem',
  marginBottom: '10px'
}

export default {
  clearfix: clearfix,
  container: {
    position: 'relative',
    minHeight: '215px',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 5px rgba(0,0,0,0.2)',
    background: 'rgba(0,0,0,0.02)',
  },
  modalContainer: {
    padding: '8px'
  },
  submitBtn: {
    background: colors.xdDarkBlue,
    display: 'block',
    margin: '16px auto 0',
    width: '100%'
  },
  submitBtnHov: {
    background: colors.xdHighlight,
  },
  error_statusContainer: {
    ...statusContainer,
    background: colors.lightRed,
    color: colors.error,
    borderColor: colors.error,
  },
  complete_statusContainer: {
    ...statusContainer,
    background: colors.lightGreen,
    color: colors.success,
    borderColor: colors.success,
  },
  statusText: {
    margin: 0,
  }
}
